import { useEffect } from 'react'

import { BroadcastChannels } from 'shared/constants/broadcast/channels'
import { NotificationsBroadcastMessages } from 'shared/constants/broadcast/notifications'
import { useUnreadCountStore } from 'shared/stores/unreadCountStore'
import { createTypedBroadcastChannel } from 'shared/utils/broadcastChannel'

const LEGACY_NOTIFICATIONS_CHANNEL = 'notification'

const isCountMap = (value: unknown): value is Record<string, number> => {
  if (!value || typeof value !== 'object') return false
  return Object.values(value).every(item => typeof item === 'number')
}

const extractUnreadCounts = (
  message: unknown
): Record<string, number> | null => {
  if (!message || typeof message !== 'object') return null

  const data = message as {
    type?: string
    payload?: unknown
    unreadCounts?: unknown
    counts?: unknown
  }

  if (data.type !== NotificationsBroadcastMessages.APP_UNREAD_COUNTS)
    return null

  if (isCountMap(data.payload)) return data.payload
  if (isCountMap(data.unreadCounts)) return data.unreadCounts
  if (isCountMap(data.counts)) return data.counts

  return null
}

export function useNotificationBadges(): void {
  const updateCounts = useUnreadCountStore(state => state.updateCounts)

  useEffect(() => {
    const channel = createTypedBroadcastChannel(BroadcastChannels.NOTIFICATIONS)

    const unsubscribe = channel.subscribe(message => {
      const counts = extractUnreadCounts(message)
      if (counts) {
        updateCounts(counts)
      }
    })
    const legacyChannel = new BroadcastChannel(LEGACY_NOTIFICATIONS_CHANNEL)
    const onLegacyMessage = (event: MessageEvent) => {
      const counts = extractUnreadCounts(event.data)
      if (counts) {
        updateCounts(counts)
      }
    }
    legacyChannel.addEventListener('message', onLegacyMessage)

    return () => {
      unsubscribe()
      channel.close()
      legacyChannel.removeEventListener('message', onLegacyMessage)
      legacyChannel.close()
    }
  }, [updateCounts])
}
